/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Demographics } from './Demographics';
import {
    DemographicsFromJSON,
    DemographicsFromJSONTyped,
    DemographicsToJSON,
    DemographicsToJSONTyped,
} from './Demographics';
import type { PayorSource } from './PayorSource';
import {
    PayorSourceFromJSON,
    PayorSourceFromJSONTyped,
    PayorSourceToJSON,
    PayorSourceToJSONTyped,
} from './PayorSource';
import type { Physician } from './Physician';
import {
    PhysicianFromJSON,
    PhysicianFromJSONTyped,
    PhysicianToJSON,
    PhysicianToJSONTyped,
} from './Physician';
import type { BasicInfo } from './BasicInfo';
import {
    BasicInfoFromJSON,
    BasicInfoFromJSONTyped,
    BasicInfoToJSON,
    BasicInfoToJSONTyped,
} from './BasicInfo';
import type { Diagnosis } from './Diagnosis';
import {
    DiagnosisFromJSON,
    DiagnosisFromJSONTyped,
    DiagnosisToJSON,
    DiagnosisToJSONTyped,
} from './Diagnosis';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
    DocumentToJSONTyped,
} from './Document';
import type { ReferralSource } from './ReferralSource';
import {
    ReferralSourceFromJSON,
    ReferralSourceFromJSONTyped,
    ReferralSourceToJSON,
    ReferralSourceToJSONTyped,
} from './ReferralSource';

/**
 * 
 * @export
 * @interface HchbCreatePatientTaskBody
 */
export interface HchbCreatePatientTaskBody {
    /**
     * 
     * @type {string}
     * @memberof HchbCreatePatientTaskBody
     */
    service_line: string;
    /**
     * 
     * @type {BasicInfo}
     * @memberof HchbCreatePatientTaskBody
     */
    basic_info: BasicInfo;
    /**
     * 
     * @type {Demographics}
     * @memberof HchbCreatePatientTaskBody
     */
    demographics: Demographics;
    /**
     * 
     * @type {Array<Document>}
     * @memberof HchbCreatePatientTaskBody
     */
    documents?: Array<Document>;
    /**
     * 
     * @type {ReferralSource}
     * @memberof HchbCreatePatientTaskBody
     */
    referral: ReferralSource;
    /**
     * 
     * @type {Array<PayorSource>}
     * @memberof HchbCreatePatientTaskBody
     */
    payor_sources?: Array<PayorSource>;
    /**
     * 
     * @type {Array<Diagnosis>}
     * @memberof HchbCreatePatientTaskBody
     */
    diagnoses: Array<Diagnosis>;
    /**
     * 
     * @type {Array<Physician>}
     * @memberof HchbCreatePatientTaskBody
     */
    physicians?: Array<Physician>;
    /**
     * 
     * @type {string}
     * @memberof HchbCreatePatientTaskBody
     */
    requested_date_of_evaluation: string;
    /**
     * 
     * @type {string}
     * @memberof HchbCreatePatientTaskBody
     */
    taskType: HchbCreatePatientTaskBodyTaskTypeEnum;
}


/**
 * @export
 */
export const HchbCreatePatientTaskBodyTaskTypeEnum = {
    CreatePatient: 'create_patient'
} as const;
export type HchbCreatePatientTaskBodyTaskTypeEnum = typeof HchbCreatePatientTaskBodyTaskTypeEnum[keyof typeof HchbCreatePatientTaskBodyTaskTypeEnum];


/**
 * Check if a given object implements the HchbCreatePatientTaskBody interface.
 */
export function instanceOfHchbCreatePatientTaskBody(value: object): value is HchbCreatePatientTaskBody {
    if (!('service_line' in value) || value['service_line'] === undefined) return false;
    if (!('basic_info' in value) || value['basic_info'] === undefined) return false;
    if (!('demographics' in value) || value['demographics'] === undefined) return false;
    if (!('referral' in value) || value['referral'] === undefined) return false;
    if (!('diagnoses' in value) || value['diagnoses'] === undefined) return false;
    if (!('requested_date_of_evaluation' in value) || value['requested_date_of_evaluation'] === undefined) return false;
    if (!('taskType' in value) || value['taskType'] === undefined) return false;
    return true;
}

export function HchbCreatePatientTaskBodyFromJSON(json: any): HchbCreatePatientTaskBody {
    return HchbCreatePatientTaskBodyFromJSONTyped(json, false);
}

export function HchbCreatePatientTaskBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbCreatePatientTaskBody {
    if (json == null) {
        return json;
    }
    return {
        
        'service_line': json['service_line'],
        'basic_info': BasicInfoFromJSON(json['basic_info']),
        'demographics': DemographicsFromJSON(json['demographics']),
        'documents': json['documents'] == null ? undefined : ((json['documents'] as Array<any>).map(DocumentFromJSON)),
        'referral': ReferralSourceFromJSON(json['referral']),
        'payor_sources': json['payor_sources'] == null ? undefined : ((json['payor_sources'] as Array<any>).map(PayorSourceFromJSON)),
        'diagnoses': ((json['diagnoses'] as Array<any>).map(DiagnosisFromJSON)),
        'physicians': json['physicians'] == null ? undefined : ((json['physicians'] as Array<any>).map(PhysicianFromJSON)),
        'requested_date_of_evaluation': json['requested_date_of_evaluation'],
        'taskType': json['taskType'],
    };
}

export function HchbCreatePatientTaskBodyToJSON(json: any): HchbCreatePatientTaskBody {
    return HchbCreatePatientTaskBodyToJSONTyped(json, false);
}

export function HchbCreatePatientTaskBodyToJSONTyped(value?: HchbCreatePatientTaskBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'service_line': value['service_line'],
        'basic_info': BasicInfoToJSON(value['basic_info']),
        'demographics': DemographicsToJSON(value['demographics']),
        'documents': value['documents'] == null ? undefined : ((value['documents'] as Array<any>).map(DocumentToJSON)),
        'referral': ReferralSourceToJSON(value['referral']),
        'payor_sources': value['payor_sources'] == null ? undefined : ((value['payor_sources'] as Array<any>).map(PayorSourceToJSON)),
        'diagnoses': ((value['diagnoses'] as Array<any>).map(DiagnosisToJSON)),
        'physicians': value['physicians'] == null ? undefined : ((value['physicians'] as Array<any>).map(PhysicianToJSON)),
        'requested_date_of_evaluation': value['requested_date_of_evaluation'],
        'taskType': value['taskType'],
    };
}

